
import { AuditSearch, AuditService, NTAudit } from "@nt-portal/server-sdk";
import { ControllerOptions, DataController } from "../../../types";
import { BaseClientService } from "../base-client.service";

export interface AuditOptions extends ControllerOptions<NTAudit> {
    filter?: AuditSearch
}


export class ClientAuditService extends BaseClientService implements DataController<NTAudit> {

    private _service: AuditService;


    constructor() {
        super();
        this._service = new AuditService({
            apiService: this.apiService,
            url: this.settings.fabrixServer
        });
    }


     public async get(options: AuditOptions) {
            let fetchParams = this.buildFetchParams(options)
            return await this._service.get(fetchParams, this.token, options.filter);
        }
    
    
        public async getById(options: AuditOptions) {
            if (options.id)
                return await this._service.getById(options.id, this.token);
            return null
        }

   
}


